import _ from 'lodash';
import { PRESCRIPTION_CANONICAL } from '../../constants/defaults';

export const getLdJson = (
  drugName,
  replaceableVariables,
  imageData,
  urlDrugName
) => {
  let imgUrl =
    !_.isEmpty(imageData && imageData.images) && imageData.images[0].url;
  let structuredData = {
    '@context': 'https://schema.org',
    url: `${PRESCRIPTION_CANONICAL}${urlDrugName}/what-is`,
    image: imgUrl,
    '@type': 'MedicalWebPage',
    about: { '@type': 'Drug', name: `${drugName}` },
    publisher: {
      '@type': 'Organization',
      name: 'SingleCare',
      logo: {
        '@type': 'ImageObject',
        url: 'https://static-singlecare.s3.amazonaws.com/tenant/singlecare/images/main-logo.png'
      }
    },
    headline: `What is ${drugName}: Uses, Warnings & Interactions`,
    description: `${replaceableVariables && replaceableVariables.description}`,
    author: {
      '@type': 'Organization',
      name: 'SingleCare'
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': 'https://www.singlecare.com/',
            name: 'Home'
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': `https://www.singlecare.com/prescription/${urlDrugName}`,
            name: `${drugName} coupons`
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@id': `https://www.singlecare.com/prescription/${urlDrugName}/what-is`,
            name: `What is ${drugName}`
          }
        }
      ]
    }
  };

  return JSON.stringify(structuredData);
};
